import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

// Custom layout
import MainLayout from "../../../../Layouts/Main";

// styles
import "./styles.scss";

// assets
import assets from "../../../../Assets";

//slice
import { fetchIndividualIndustryTraining } from "../../../../Redux/Slices/contentManagementSlice";

const ViewIndustryTraining = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [industryTrainingData, setIndustryTrainingData] = useState(null);
    const LEARNING_TYPE = {
      1: "Reading and Writing",
      2: "Visual",
      3: "Auditory",
      4: "Kinesthetic",
    };

    useEffect(() => {
        dispatch(
          fetchIndividualIndustryTraining({
            data: {
              id: id
            },
            callBack: fetchIndustryTrainingCB,
          })
        );
    }, [id]);

    const fetchIndustryTrainingCB = (data) => {
        console.log(data.result);
        setIndustryTrainingData(data.result);
    };

    return (
      <MainLayout pageName={"Content Management"}>
        <div className="goBackDiv" onClick={() => navigate(-1)}>
          <img src={assets.Icons.leftArrow} alt="backIcon" />
          <p>Back to Industry Training List</p>
        </div>
        <div className="industry-training-profile-details">
          <div className="view-industry-training-container-header">
            <h2>View Industry Training Details</h2>
          </div>

          <hr style={{ backgroundColor: "#E6E6E6" }} />

          <div className="industry-training-details-container">
            {industryTrainingData ? (
              <>
                <div style={{ fontWeight: "600", marginBottom: "25px" }}>
                  Training Details
                </div>
                <div className="industry-training-details-item">
                  <div className="objKey">Learning Title</div>
                  <div>
                    : {industryTrainingData.learning_title ?? "Not Captured"}
                  </div>
                </div>
                <div className="industry-training-details-item">
                  <div className="objKey">Description</div>
                  <div>
                    : {industryTrainingData.description ?? "Not Captured"}
                  </div>
                </div>
                <div className="industry-training-details-item">
                  <div className="objKey">Category</div>
                  <div>
                    : {industryTrainingData.category_name ?? "Not Captured"}
                  </div>
                </div>
                <div className="industry-training-details-item">
                  <div className="objKey">Learning Type</div>
                  <div>
                    :{" "}
                    {LEARNING_TYPE[industryTrainingData.learning_type] ??
                      "Not Captured"}
                  </div>
                </div>
                {/* <div className="industry-training-details-item">
                                <div className="objKey">File Type</div>
                                <div>: {industryTrainingData.file_type ?? "Not Captured"}</div>
                            </div> */}
                <div className="industry-training-details-item">
                  <div className="objKey">File</div>
                  <div>
                    :{" "}
                    {industryTrainingData.file_url ? (
                      <a href={industryTrainingData.file_url}>
                        {industryTrainingData.file_url.split("---").pop()}
                      </a>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
                <div className="industry-training-details-item">
                  <div className="objKey">File Link</div>
                  <div>
                    :{" "}
                    {industryTrainingData.content_link ? (
                      <a
                        href={
                          industryTrainingData.content_link.startsWith("http")
                            ? industryTrainingData.content_link
                            : `https://${industryTrainingData.content_link}`
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {industryTrainingData.content_link}
                      </a>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
                {/* <a href={industryTrainingData.file_url}>File</a> */}
              </>
            ) : (
              ""
            )}
          </div>
        </div>
      </MainLayout>
    );
};

export default ViewIndustryTraining;
